import { RootState } from 'store';

export const getApplyProcessState = (state: RootState) => state.applyProcess;
export const getWelcomeProcessData = (state: RootState) => state.applyProcess.welcomeProcessData;
export const getApplyProcessData = (state: RootState) => state.applyProcess.applyProcessData;
export const getContactInformationData = (state: RootState) =>
  state.applyProcess.contactInformationData;
export const getSignInProcessState = (state: RootState) => state.signInProcess;
export const getApplicationSelector = (state: RootState) => state.applicationProcess.application;
export const getEmailVerificationData = (state: RootState) =>
  state.verificationProcess.emailVerificationData;
export const getPhoneVerificationData = (state: RootState) =>
  state.verificationProcess.phoneVerificationData;

export const getBorrowerDetails = (state: RootState) => {
  const { firstName, lastName, phone, email } = state.signInProcess.accountData!;
  return {
    firstName,
    lastName,
    phone,
    email,
  };
};
